module.exports = __webpack_public_path__ + "img/weibao.8c1dd1c0.png";